var React = require('react');

function LightDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 13.5H14","stroke":"white","key":0}),React.createElement("path",{"d":"M8 8L8 4","stroke":"white","strokeWidth":"4","strokeLinecap":"square","key":1}),React.createElement("path",{"d":"M8 13L14 8L2 8L8 13Z","fill":"white","key":2})]);
}

LightDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LightDown;

LightDown.default = LightDown;
